import { isArray } from 'lodash';
import { DialogSize } from '../../../../../react-commons/components/data-display/dialog/ResizableDialog';
import { ResourceType } from '../../../resource/enumerations/ResourceType';

export const getDialogSizeForResourceType = (resourceType: ResourceType): DialogSize => {
    switch (resourceType) {
        default:
            return DialogSize.MEDIUM;
    }
};

export const getMaximalDialogSizeForResourceTypes = (resourceTypes?: ResourceType[] | ResourceType): DialogSize => {
    if (!resourceTypes) {
        return DialogSize.MEDIUM
    }
    const finalResourceTypes = !isArray(resourceTypes) ? [resourceTypes] : resourceTypes;

    let dialogSize: DialogSize = DialogSize.MEDIUM;

    for (const resourceType of finalResourceTypes) {
        const currentSize: DialogSize = getDialogSizeForResourceType(resourceType);

        switch (currentSize) {
            case DialogSize.MEDIUM_LARGE:
                dialogSize = DialogSize.MEDIUM_LARGE;
                break;
            case DialogSize.LARGE:
                dialogSize = DialogSize.LARGE;
        }
    }

    return dialogSize;
};
